import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Bouton from '../Button/Bouton';
import messages from './messages';

interface IProps {
  children?: JSX.Element | JSX.Element[] | string;
  error?: any; // FIXME Typer l'erreur
  loading?: boolean;
  onRetry?(): void;
  message?: string;
  className?: string;
}

/**
 * Composant pour gérer les chargements en cours :
 * - Affichage d'un loader si chargement en cours
 * - Affichage d'un message et d'un bouton "Réessayer" en cas d'erreur
 * - Affichage des enfants sinon
 */
const LoadingErrorBoundary: React.FC<IProps> = ({
  children,
  error,
  loading,
  onRetry,
  message,
}) => {
  if (loading) {
    return (
      <div
        style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}
      >
        <Typography align="center" variant="body2" className="message">
          {message || messages.loadingErrorMessage}
        </Typography>
        {onRetry && (
          <Bouton
            label={messages.retry}
            variant="contained"
            color="primary"
            size="medium"
            onClick={onRetry}
          />
        )}
      </div>
    );
  }

  return <>{children}</>;
};

export default LoadingErrorBoundary;
